



















import { Component, Mixins, } from "vue-property-decorator";
import DepartmentFinder from "../../../selectors/DepartmentFinder.vue";
import { DepartmentButtonSelectorDialogMixin } from "../../mixins";

@Component({
  components: {
    selector: DepartmentFinder,
  },
})
export default class DepartmentButtonSelectorDialog extends Mixins(DepartmentButtonSelectorDialogMixin) {
}
